import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { BreadcrumbsComponent } from '../breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'aos-page',
  imports: [BreadcrumbsComponent, RouterOutlet],
  template: `
    <aos-breadcrumbs></aos-breadcrumbs>
    <main
      [class.listing-layout]="hasListingLayout"
      [class.aos-device-details-layout]="hasDeviceDetailsLayout"
    >
      <router-outlet (activate)="activate($event)"></router-outlet>
    </main>
  `,
  styles: `
    main {
      height: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent {
  protected pageComponent: Type<Component> | null = null;
  protected hasListingLayout = false;
  protected hasDeviceDetailsLayout = false;

  activate(cmp: (Type<Component> & { route?: ActivatedRoute }) | null): void {
    this.pageComponent = cmp;
    this.hasListingLayout = cmp?.route?.snapshot?.data?.hasListingLayout;
    this.hasDeviceDetailsLayout = cmp?.route?.snapshot?.data?.hasDeviceDetailsLayout;
  }
}
